export const manifest = {
  screens: {
    scr_lirdnq: { name: "Workspace", route: "/", state: {"tool":null,"tour":-1}, position: {"x":160,"y":2200} },
    scr_ayxggt: { name: "Onboarding · Introducing Protect", route: "/", state: {"tour":0}, position: {"x":160,"y":220} },
    scr_7laha8: { name: "Onboarding · Paint protected surfaces", route: "/", state: {"tour":1}, position: {"x":1560,"y":220} },
    scr_9xq3e2: { name: "Onboarding · Explain with words", route: "/", state: {"tour":2}, position: {"x":2960,"y":220} },
    scr_7muwyd: { name: "Onboarding · Support Profiles", route: "/", state: {"tour":3}, position: {"x":4360,"y":220} },
    scr_bqt6t0: { name: "Onboarding · Project History", route: "/", state: {"tour":4}, position: {"x":5760,"y":220} },
    scr_ojp98q: { name: "Onboarding · Restore a version", route: "/", state: {"tour":5}, position: {"x":7160,"y":220} },
    scr_bsdmux: { name: "Onboarding · New export options", route: "/", state: {"tour":6}, position: {"x":8560,"y":220} },
    scr_rfwohk: { name: "What changed?", route: "/", state: {"tour":-1,"whatsNew":true}, position: {"x":1560,"y":2200} },
    scr_h4lkod: { name: "1-Click Print", route: "/", state: {"tool":"oneclick","tour":-1}, position: {"x":160,"y":4180} },
    scr_r4ihp3: { name: "Size", route: "/", state: {"tool":"size","tour":-1}, position: {"x":160,"y":6160} },
    scr_a6ifok: { name: "Protect Surfaces", route: "/", state: {"tool":"protect","tour":-1}, position: {"x":160,"y":8140} },
    scr_0yjz4o: { name: "Orientation", route: "/", state: {"tool":"orient","tour":-1}, position: {"x":1560,"y":6160} },
    scr_fabk6u: { name: "Supports", route: "/", state: {"tool":"support","tour":-1}, position: {"x":1560,"y":8140} },
    scr_skfl3v: { name: "Layout", route: "/", state: {"tool":"layout","tour":-1}, position: {"x":2960,"y":6160} },
    scr_o3rsaq: { name: "Hollow", route: "/", state: {"tool":"hollow","tour":-1}, position: {"x":2960,"y":8140} },
    scr_4d81bz: { name: "Texture", route: "/", state: {"tool":"texture","tour":-1}, position: {"x":4360,"y":6160} },
    scr_9e1ibc: { name: "Label", route: "/", state: {"tool":"label","tour":-1}, position: {"x":5760,"y":6160} },
    scr_1d0xmv: { name: "Drill Hole", route: "/", state: {"tool":"hole","tour":-1}, position: {"x":4360,"y":8140} },
    scr_w1kuo2: { name: "Project History", route: "/", state: {"history":true,"tour":-1}, position: {"x":160,"y":10120} },
  },
  sections: {
    sec_tmq2y8: { name: "Onboarding flow", x: 0, y: 0, width: 9920, height: 1180 },
    sec_c4o1qb: { name: "Main workspace", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_q8yznp: { name: "Print & export", x: 0, y: 3960, width: 1520, height: 1180 },
    sec_18q5zg: { name: "Print settings", x: 0, y: 5940, width: 7120, height: 1180 },
    sec_6n2m0q: { name: "Surface & feature management", x: 0, y: 7920, width: 5720, height: 1180 },
    sec_r3vpja: { name: "Project history", x: 0, y: 9900, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_tmq2y8", children: [
      { kind: "screen", id: "scr_ayxggt" },
      { kind: "screen", id: "scr_7laha8" },
      { kind: "screen", id: "scr_9xq3e2" },
      { kind: "screen", id: "scr_7muwyd" },
      { kind: "screen", id: "scr_bqt6t0" },
      { kind: "screen", id: "scr_ojp98q" },
      { kind: "screen", id: "scr_bsdmux" },
    ] },
    { kind: "section", id: "sec_c4o1qb", children: [
      { kind: "screen", id: "scr_lirdnq" },
      { kind: "screen", id: "scr_rfwohk" },
    ] },
    { kind: "section", id: "sec_q8yznp", children: [
      { kind: "screen", id: "scr_h4lkod" },
    ] },
    { kind: "section", id: "sec_18q5zg", children: [
      { kind: "screen", id: "scr_r4ihp3" },
      { kind: "screen", id: "scr_0yjz4o" },
      { kind: "screen", id: "scr_skfl3v" },
      { kind: "screen", id: "scr_4d81bz" },
      { kind: "screen", id: "scr_9e1ibc" },
    ] },
    { kind: "section", id: "sec_6n2m0q", children: [
      { kind: "screen", id: "scr_a6ifok" },
      { kind: "screen", id: "scr_fabk6u" },
      { kind: "screen", id: "scr_o3rsaq" },
      { kind: "screen", id: "scr_1d0xmv" },
    ] },
    { kind: "section", id: "sec_r3vpja", children: [
      { kind: "screen", id: "scr_w1kuo2" },
    ] },
  ],
}
